// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUrlWithqueries = (baseUrl: string, queries: any): string => {
  let newUrl = baseUrl;
  let counter = 0;

  for (const property in queries) {
    if (String(queries[property]).length) {
      // Encode the parameter value to handle special characters
      const encodedValue = encodeURIComponent(String(queries[property]));
      newUrl = `${newUrl}${counter === 0 ? "?" : "&"}${property}=${encodedValue}`;
      counter++;
    }
  }
  return newUrl;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getBodyWithQueries = (queries: any): any => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const body: Record<string, any> = {};
  for (const property in queries) {
    if (String(queries[property]).length) {
      body[property] = String(queries[property]);
    }
  }
  return body;
};
